import React from 'react';
import { Link } from 'react-router-dom';

export default class ContactInfoCard extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("ContactInfoCard", this.props)
		return (
			<div className="ContactInfoCard bg-white">
				<div
					className={`w-full px-6 py-4 ${this.props.hasBorder &&
						'border border-gray-300 rounded-md shadow-sm'}`}
				>
					<h2 className="text-md md:text-xl text-center pb-4">Need help?</h2>
					<div className="text-sm md:text-lg">
						<div className="py-2">
							<h3 className="mb-1">Email us</h3>
							<Link to="mailTo:signup@travltax.com">
								<i className="fa fa-envelope" />
								<span> support@travltax.com</span>
							</Link>
						</div>
						<div className="py-2">
							<h3 className="mb-1 mt-3">Call us</h3>
							<Link to="tel:1-800-847-7766">
								<i className="fas fa-phone" />
								<span> 1-800-847-7777</span>
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
